import { SearchBar } from "../form/SearchBar";
import React from "react";
import { useNavigate } from "react-router-dom";

export function MenuBuilder(props) {
  const navigate = useNavigate();
  let user = JSON.parse(localStorage.getItem("user"));

  return (
    <>
      <div className="flex flex-row flex-wrap items-start justify-start w-full px-4 py-2 ">
        <h2 className="text-4xl font-extrabold">{props.name}</h2>
      </div>
      <div className="flex flex-row flex-wrap items-start justify-start w-full px-4 py-2 ">
        <SearchBar
          styles="w-full md:w-1/3"
          text={"Search Menu"}
          funcs={props.menuController}
        />
      </div>
      <div className="flex flex-row flex-wrap items-start justify-start w-full px-2 py-2">
        {props.listMenu.map(({ auth, name, path }, id) => {
          return (
            auth !== "" &&
            user.Otoritas[auth] !== 0 &&
            user.Otoritas[auth] &&
            user.Otoritas[auth] != null && (
              <a
                key={`menu-${auth}-${id}`}
                onClick={() => navigate(path)}
                className="w-full md:w-1/5 block px-6 pb-2 pt-4 m-2 max-w-sm bg-white rounded-lg border border-main-100 shadow-md hover:bg-main-100 hover:text-white text-gray-900"
              >
                <h5 className="mb-2 text-xl font-bold tracking-tight  ">
                  {name}
                </h5>
              </a>
            )
          );
        })}
      </div>
    </>
  );
}
